import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { userLoggedOut } from "../redux/features/auth/authSlice";
import logo from "../assets/images/learningportal.svg";
import gravatarUrl from "gravatar-url";

export default function NavBar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [users, setUsers] = useState({});
  const [dashboardStudent, setDashboardStudent] = useState(false);
  const [dashboardAdmin, setDashboardAdmin] = useState(false);

  const [leaderboardActive, setLeaderboardActive] = useState(false);

  const currentPath = window.location.pathname;

  useEffect(() => {
    if (localStorage.getItem("auth")) {
      setUsers(JSON.parse(localStorage.getItem("auth")).user);
    }

    if (currentPath === `/student/${users.id}/leaderboard`) {
      setLeaderboardActive(true);
    } else {
      setLeaderboardActive(false);
    }

    if (currentPath.includes(`/student/${users.id}/videos`)) {
      setDashboardStudent(true);
    } else {
      setDashboardStudent(false);
    }

    if (currentPath.includes(`/admin/dashboard`)) {
      setDashboardAdmin(true);
    } else {
      setDashboardAdmin(false);
    }
  }, [currentPath, users.id]);

  const handleHome = () => {
    if (users?.role === "admin") {
      navigate("/admin/dashboard");
    } else if (users?.role === "student") {
      navigate(`/student/${users.id}/videos/1`);
    } else navigate("/");
  };

  const handleLogout = () => {
    if (!window.confirm("Are you sure you want to logout?")) return;
    if (users?.role === "admin") navigate(`/admin/login`);
    else if (users?.role === "student") navigate(`/student/login`);
    else navigate("/");

    dispatch(userLoggedOut());
    localStorage.removeItem("auth");
  };

  return (
    <nav className="shadow-md fixed top-0 left-0 w-full z-10 bg-primary border-b border-slate-600/50">
      <div className="max-w-7xl px-5 lg:px-0 mx-auto flex justify-between py-3">
        <img
          className="h-10"
          style={{ cursor: "pointer" }}
          src={logo}
          alt="Learning Portal"
          onClick={handleHome}
        />

        {users.role === "student" && (
          <div className="flex items-center gap-3">
            <Link to={`/student/${users?.id}/videos/1`}>
              <span
                className={`${
                  dashboardStudent &&
                  "px-4 py-2 rounded-full text-cyan bg-cyan bg-opacity-10"
                }`}
              >
                Dashboard
              </span>
            </Link>

            <Link to={`/student/${users?.id}/leaderboard`}>
              <span
                className={`${
                  leaderboardActive &&
                  "px-4 py-2 rounded-full text-cyan bg-cyan bg-opacity-10"
                }`}
              >
                Leaderboard
              </span>
            </Link>

            <h2
              className="font-bold"
              style={{
                display: "grid",
                alignItems: "center",
                gridTemplateColumns: "auto 1fr",
                columnGap: "0.5rem",
              }}
            >
              <span>
                <img
                  className="object-cover w-6 h-6 rounded-full"
                  src={gravatarUrl(users?.email, { size: 80 })}
                  alt={users?.name}
                />
              </span>
              {users?.name}
            </h2>

            <button
              className="flex gap-2 border border-cyan items-center px-4 py-1 rounded-full text-sm transition-all hover:bg-cyan"
              onClick={handleLogout}
            >
              <svg
                className="w-6 h-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
                />
              </svg>
              Logout
            </button>
          </div>
        )}

        {users.role === "admin" && (
          <div className="flex items-center gap-3">
            <Link to={`/admin/dashboard`}>
              <span
                className={`${
                  dashboardAdmin &&
                  "px-4 py-2 rounded-full text-cyan bg-cyan bg-opacity-10"
                }`}
              >
                Dashboard
              </span>
            </Link>

            <h2
              className="font-bold"
              style={{
                display: "grid",
                alignItems: "center",
                gridTemplateColumns: "auto 1fr",
                columnGap: "0.5rem",
              }}
            >
              <span>
                <img
                  className="object-cover w-6 h-6 rounded-full"
                  src={gravatarUrl(users?.email, { size: 80 })}
                  alt={users?.name}
                />
              </span>
              {users?.name}
            </h2>

            <button
              className="flex gap-2 border border-cyan items-center px-4 py-1 rounded-full text-sm transition-all hover:bg-cyan"
              onClick={handleLogout}
            >
              <svg
                className="w-6 h-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
                />
              </svg>
              Logout
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}
